import { useMemo } from "react";
import { cva } from "class-variance-authority";
import { cn } from "web-design-system";
import { GoalCategory } from "creso-core/types";
import {
  BookOpenTextIcon,
  CarIcon,
  GemIcon,
  HomeIcon,
  LucideIndianRupee,
  RockingChair,
} from "lucide-react";

export const GoalIconMap: Record<
  GoalCategory,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  CAR: CarIcon,
  HOUSE: HomeIcon,
  MARRIAGE: GemIcon,
  CHILD_EDU: BookOpenTextIcon,
  RETIREMENT: RockingChair,
  CUSTOM: LucideIndianRupee,
};

const variants = cva(
  "size-9 rounded-lg flex items-center justify-center flex-shrink-0",
  {
    variants: {
      category: {
        CAR: "bg-tag-blue text-tag-blue-foreground",
        HOUSE: "bg-name-tag-rose text-name-tag-rose-foreground",
        MARRIAGE: "bg-tag-orange text-tag-orange-foreground",
        CHILD_EDU: "bg-tag-lime text-tag-lime-foreground",
        RETIREMENT: "bg-name-tag-emerald text-name-tag-emerald-foreground",
        CUSTOM: "bg-tag-grey text-tag-grey-foreground [&>svg]:size-5",
      } as Record<GoalCategory, string>,
    },
    defaultVariants: {
      category: "CUSTOM",
    },
  }
);

export function GoalIcon(props: {
  category?: GoalCategory;
  className?: string;
}) {
  const { category = "CUSTOM", className } = props;
  const Icon = useMemo(
    () => GoalIconMap[(category as keyof typeof GoalIconMap) ?? "CUSTOM"],
    [category]
  );
  if (!Icon) return null;
  return (
    <div
      className={cn(variants({ category: category || "CUSTOM" }), className)}
    >
      {Icon && <Icon className="size-6" />}
    </div>
  );
}
